/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';
import File from 'ContentComponents/cmv2/fields/File';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { FILE as FILE_FIELD_TYPE } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DrawerTypes } from 'FileManagerLib/Constants';
import { DEFAULT, PICKER } from 'DesignData/enums/CustomWidgetFieldAttributes';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

const ORDERED_FM_DRAWER_TYPES = [DrawerTypes.FILE, DrawerTypes.IMAGE, DrawerTypes.VIDEO, DrawerTypes.DOCUMENT];
export default class _class extends Component {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };

    this.onPickerChange = e => {
      this.props.editField({
        [PICKER]: e.target.name
      });
    };

    this.renderPickerRadios = () => {
      const {
        field,
        readOnly
      } = this.props;
      return ORDERED_FM_DRAWER_TYPES.reduce((acc, typeKey) => {
        const type = DrawerTypes[typeKey].toLowerCase();
        acc.push( /*#__PURE__*/_jsx(UIRadioInput, {
          checked: field[PICKER] === type,
          disabled: readOnly,
          name: type,
          onChange: this.onPickerChange,
          children: I18n.text(i18nKey(`file.pickerTypes.${type}`))
        }, type));
        return acc;
      }, []);
    };
  }

  render() {
    const {
      field,
      readOnly,
      fieldErrors
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(ToolFieldset, {
        children: [/*#__PURE__*/_jsx(ToolFormControl, {
          label: I18n.text(i18nKey('file.pickerLabel')),
          children: /*#__PURE__*/_jsx("div", {
            children: this.renderPickerRadios()
          })
        }), /*#__PURE__*/_jsx(FormControlWithErrors, {
          "aria-label": "value",
          errors: fieldErrors[DEFAULT],
          children: /*#__PURE__*/_jsx(SidebarInput, {
            inputComponent: File,
            label: I18n.text(i18nKey(`defaultLabels.${FILE_FIELD_TYPE}`)),
            onFieldChange: this.onDefaultChange,
            picker: field[PICKER],
            value: field[DEFAULT],
            wrap: true,
            readOnly: readOnly
          })
        })]
      })
    });
  }

}
_class.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool,
  fieldErrors: PropTypes.object
};